import React from 'react'
import { Form, FormGroup, Label, Input } from 'reactstrap'
import _ from 'lodash'
import MultiLangRTE from 'components/RTE/MultiLang'
import Lang from 'Lang/General'

const ImprintForm = ({
  selectedImprint,
  onChangeImprintHOC,
  lang
}) => {
  return (
    <Form onSubmit={ e => e.preventDefault() }>
      <FormGroup>
        <Label>{ Lang[ 'CENTER' ][ lang ] }</Label>
        <Input
          disabled
          type="text"
          value={ selectedImprint.center_name } />
      </FormGroup>
      <MultiLangRTE
        label={ Lang[ 'CONTENT' ][ lang ] }
        value={ selectedImprint.content } 
        onChange={ val => {
          let tmp = _.cloneDeep( selectedImprint )
          tmp.content = val
          onChangeImprintHOC( 'selectedImprint', tmp )
        }}
        selectedLanguage={ lang } />
    </Form>
  )
}

export default ImprintForm 
